import Navbar from "../components/Navbar";
import {
  FaWhatsapp,
  FaInstagram,
  FaLinkedin,
  FaFacebook,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";

export default function ContactenosForm() {
  return (
    <div className="min-h-screen bg-[#1f1b24] text-white font-nexa font-normal">
      {/* Navbar */}
      <Navbar />

      {/* ======= SECCIÓN: Contáctenos ======= */}
      <section className="max-w-5xl mx-auto px-6 md:px-12 py-16">
        {/* Título principal */}
        <div className="flex justify-start mb-12">
          <div
            className="inline-block text-[#1f1b24] font-extrabold text-2xl md:text-3xl px-8 py-4 rounded-2xl shadow-lg"
            style={{
              background: "linear-gradient(90deg, #00b3b3, #00e68a)",
            }}
          >
            Contáctenos
          </div>
        </div>

        {/* Subtítulo */}
        <h2 className="text-[#00e68a] font-bold text-xl md:text-2xl mb-4">
          QuarkIA está lista para atender
        </h2>

        <p className="text-lg leading-relaxed text-justify mb-10">
          En <strong className="text-[#00b3b3]">QuarkIA</strong> se valora la comunicación directa con los clientes.
          Para resolver preguntas, solicitar una demostración de los servicios o
          recibir asesoría en soluciones de transformación digital, el equipo
          se encuentra disponible para brindar atención.
        </p>

        {/* ======= FORMULARIO DE CONTACTO ======= */}
        <form className="bg-[#2a2533] p-8 rounded-2xl shadow-lg space-y-6">
          <div>
            <label className="block text-[#00e68a] font-semibold mb-2">
              Nombre:
            </label>
            <input
              type="text"
              placeholder="Nombre del usuario"
              className="w-full px-4 py-3 rounded-lg bg-[#1f1b24] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#00e68a]"
            />
          </div>

          <div>
            <label className="block text-[#00e68a] font-semibold mb-2">
              Apellidos:
            </label>
            <input
              type="text"
              placeholder="Apellidos del usuario"
              className="w-full px-4 py-3 rounded-lg bg-[#1f1b24] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#00e68a]"
            />
          </div>

          <div>
            <label className="block text-[#00e68a] font-semibold mb-2">
              Celular:
            </label>
            <input
              type="tel"
              placeholder="+57 311 383 6855"
              className="w-full px-4 py-3 rounded-lg bg-[#1f1b24] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#00e68a]"
            />
          </div>

          <div>
            <label className="block text-[#00e68a] font-semibold mb-2">
              Correo electrónico:
            </label>
            <input
              type="email"
              placeholder="correo@ejemplo.com"
              className="w-full px-4 py-3 rounded-lg bg-[#1f1b24] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#00e68a]"
            />
          </div>

          <div>
            <label className="block text-[#00e68a] font-semibold mb-2">
              Mensaje (opcional):
            </label>
            <textarea
              rows="5"
              placeholder="Contenido del mensaje..."
              className="w-full px-4 py-3 rounded-lg bg-[#1f1b24] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#00e68a]"
            ></textarea>
          </div>

          {/* Botón enviar */}
          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-gradient-to-r from-[#00b3b3] to-[#00e68a] text-[#1f1b24] font-semibold px-8 py-3 rounded-xl mt-6 hover:scale-105 transition-transform"
            >
              Enviar
            </button>
          </div>
        </form>

        {/* Información de contacto adicional */}
        <div className="mt-12 text-center">
          <p className="text-lg text-gray-300">
            También es posible establecer contacto a través del correo{" "}
            <span className="text-[#00e68a] font-semibold">info@quarkia.com.co</span>
            {" "}o de la línea telefónica{" "}
            <span className="text-[#00e68a] font-semibold">+57 311 383 6855</span>.
          </p>
        </div>

        {/* ======= FOOTER ======= */}
        <footer className="bg-[#16131a] py-8 text-center border-t border-gray-700 mt-16">
          <div className="flex flex-col items-center space-y-4">
            <div className="flex space-x-6 text-2xl text-[#00b3b3]">
              <a
                href="https://wa.me/573001234567"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#00ff80] transition"
              >
                <FaWhatsapp />
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#00ff80] transition"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#00ff80] transition"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#00ff80] transition"
              >
                <FaFacebook />
              </a>
            </div>

            {/* 📧 y 📞 */}
            <div className="flex flex-col items-center text-sm md:text-base space-y-2">
              <p className="flex items-center space-x-2">
                <FaEnvelope className="text-[#00b3b3]" />
                <span>info@quarkia.com.co</span>
              </p>
              <p className="flex items-center space-x-2">
                <FaPhoneAlt className="text-[#00b3b3]" />
                <span>+57 311 383 6855</span>
              </p>
            </div>

            <p className="text-gray-400 text-xs mt-4">
              © {new Date().getFullYear()} QuarkIA S.A.S. All rights reserved.
            </p>
          </div>
        </footer>
      </section>
    </div>
  );
}
